import { useEffect } from "react";
import { NaeSSchemaMap } from "../../config/NaeSSchema";
import { useDataCache } from "./DataCacheProvider";
import { useSelector } from "react-redux";
import { SelectorDriverTripNae } from "../Models/ormSelectors";

interface ChildId {
  id: number
}

export interface IDriverTripModelNae {
    id: number,
scopes: any,
badges: any,

}

export const IDriverTripFieldsNae = [
    "id",
    "scopes",
    "badges"
];

export function useDriverTripHookNae(id: number) : IDriverTripModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorDriverTripNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.DriverTrip.schema,
        fields: IDriverTripFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
